import moment from "moment/dist/moment";
import numeral from "numeral";

numeral.register("locale", "fr", {
  delimiters: {
    thousands: ".",
    decimal: ","
  },
  abbreviations: {
    thousand: "k",
    million: "m",
    billion: "b",
    trillion: "t"
  },
  ordinal: function(number) {
    return number === 1 ? "er" : "ème";
  },
  currency: {
    symbol: "€"
  }
});
numeral.locale("fr");

export default {
  computed: {
    isMobile() {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }
  },
  methods: {
    formatDate(date) {
      if (date) {
        return moment(date).format("DD-MM-YYYY HH:mm");
      }
    },
    formatPrice(value) {
      return value ? numeral(value).format("0,0.00") : "0";
    },
    formatNum(value) {
      return value ? numeral(value).format("0,0.0") : "0";
    },
    formatQty(value) {
      return value ? numeral(value).format("0,0") : "0";
    }
  }
};
